import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  LocationCity,
  LocationCountry,
} from '../../utils/Constants';
import { CONTACT_PAGE_URL } from '../../utils/Routes';
// Images
import WellnessImage from '../../assets/images/wellness/wellness.webp';
// Icons
import { MdDoubleArrow } from 'react-icons/md';

function WellnessPageHeader() {
  return (
    <header className='grid min-h-screen pt-[102px] lg:pt-[84px] w-full h-full overflow-x-hidden'>
      {/* Phone */}
      <section className='grid lg:hidden px-8 py-4 w-full'>
        <article className='grid justify-center gap-y-8'>
          <div className='grid h-fit gap-y-8 text-center'>
            <h1
              className='font-titleFont text-4xl w-full text-colour5 tracking-wide'
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
            >
              Wellness Coaching
            </h1>
            <div className='text-base font-titleFont text-center px-8'>
              <h2>Coaching that works for you!</h2>
            </div>
          </div>

          <div className='grid justify-center'>
            <img
              src={WellnessImage}
              alt='Wellness coaching — calming scene'
              className='w-full h-full object-cover rounded-xl'
              loading='lazy'
              decoding='async'
            />
          </div>

          <div className='text-center md:text-xl'>
            <ul className='grid gap-2 list-none'>
              <li>
                ✨ Helping you break free from limits & create a lifestyle you
                love.
              </li>
              <li>
                ✨ Tailored{' '}
                <span className='font-semibold'>
                  mindset & lifestyle coaching
                </span>{' '}
                with weekly check-ins.
              </li>
              <li>
                ✨ From <span className='font-semibold'>2500 kr/month</span>.
              </li>
              <li>
                ✨ Available{' '}
                <span className='font-semibold'>
                  online, 1:1, or group sessions
                </span>
                .
              </li>
            </ul>
          </div>

          <div className='grid h-fit px-8 text-center'>
            <Link
              to={CONTACT_PAGE_URL}
              aria-label='Contact me about wellness coaching'
              className='grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
            >
              <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4'>
                <span>BOOK COACHING NOW</span>
                <MdDoubleArrow className='text-xl' />
              </div>
            </Link>
          </div>

          {/* Cta */}
          <section className='grid gap-x-2 w-full justify-center text-center'>
            <Link
              to={CONTACT_PAGE_URL}
              className='text-colour5 underline hover:brightness-75 text-center'
              aria-label='Get in touch with Siv Renate'
              title='Contact Siv Renate for inquiries, bookings, or collaborations'
            >
              Contact
            </Link>
          </section>
        </article>
      </section>

      {/* Large screen */}
      <section className='hidden relative lg:grid w-full'>
        {/* LEFT rail */}
        <div className='absolute inset-y-0 left-0 w-12 z-20 grid place-items-center'>
          <span className='[writing-mode:vertical-rl] rotate-180 [text-orientation:mixed] underline underline-offset-4'>
            From {LocationCity}, {LocationCountry}
          </span>
        </div>

        {/* RIGHT rail */}
        <div className='absolute inset-y-0 right-0 w-12 z-20 grid place-items-center'>
          <span className='[writing-mode:vertical-rl] rotate-180 [text-orientation:mixed] underline underline-offset-4'>
            Mindset · Balance · Growth
          </span>
        </div>

        <div className='absolute grid w-full h-full items-center transform top-1/2 -translate-y-1/2 px-44'>
          <img
            src={WellnessImage}
            alt='Wellness coaching — calming scene'
            className='w-full h-full object-cover rounded-xl max-h-[60vh]'
            loading='lazy'
            decoding='async'
          />
        </div>

        <article className='grid w-full h-full pt-16 items-center z-20'>
          <section className='relative px-12 pl-20 grid items-center'>
            <div className='hidden lg:block text-2xl font-titleFont pb-4 pl-44 text-colour1 text-left'>
              <h2
                className='text-sm'
                style={{ textShadow: '4px 4px 6px rgba(0,0,0,0.9)' }}
              >
                Coaching that works for you!
              </h2>
            </div>
            <h1
              className='font-agraham text-[5rem] 2xl:text-[6rem] w-full text-colour5 tracking-wide'
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
            >
              Wellness Coaching
            </h1>
            <div className='grid h-fit grid-cols-rev pr-8 pt-8 pl-44'>
              <div
                className='grid items-center text-center text-colour1'
                style={{ textShadow: '4px 4px 6px rgba(0,0,0,0.9)' }}
              >
                <ul className='grid gap-2 text-sm xl:text-lg max-w-[50vw] list-none'>
                  <li>
                    ✨ Helping you break free from limits & create a lifestyle
                    you love.
                  </li>
                  <li>
                    ✨ Tailored{' '}
                    <span className='font-semibold'>
                      mindset & lifestyle coaching
                    </span>{' '}
                    with weekly check-ins.
                  </li>
                  <li>
                    ✨ From <span className='font-semibold'>2500 kr/month</span>
                    .
                  </li>
                  <li>
                    ✨ Available{' '}
                    <span className='font-semibold'>
                      online, 1:1, or group sessions
                    </span>
                    .
                  </li>
                </ul>
              </div>
            </div>
            <div className='grid h-fit px-8 text-center justify-start pt-12'>
              <Link
                to={CONTACT_PAGE_URL}
                aria-label='Contact me about wellness coaching'
                className='grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
              >
                <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4'>
                  <span>BOOK COACHING NOW</span>
                  <MdDoubleArrow className='text-xl' />
                </div>
              </Link>
            </div>
          </section>
        </article>
      </section>
    </header>
  );
}

export default WellnessPageHeader;
